import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";
import { localStoreKeys } from "../../constants/localStoreKeys";
import { setKeyValue } from "../reducer/localDataSlice";

const FetchLandingPageAction = (oktaTokenData = 'test.user@pepsico.com') => {
    return async function (dispatch) {
        const email = oktaTokenData?.email
        if (email) {
            const data = await getApiCall(`${appConstants.BASE_URL}/user/user-info?emailId=${email}`);
            // const data = await getApiCall(`${appConstants.BASE_URL}/user/user-info?emailId=surta.ram.contractor@pepsico.com`);
            // const data = await getApiCall(`${appConstants.BASE_URL}/user/user-info?emailId=rishikeshramesh.patil@fractal.ai`);
            var resData = Object.assign({ type: 'SUCCESS_LANDING_PAGE_ACTION' }, data);
            dispatch(setKeyValue({ key: localStoreKeys.userDefaultRole, value: resData?.defaultRole }))
            dispatch(setKeyValue({ key: localStoreKeys.userEmailID, value: resData?.emailId }))
            return dispatch(resData);
        }
    };
};

const FetchUserInfoV2LandingPageAction = (oktaTokenData = 'test.user@pepsico.com') => {
    return async function (dispatch) {
        const email = oktaTokenData?.email
        if (email) {
            const data = await getApiCall(`${appConstants.BASE_URL}/user/user-info-v2?emailId=${email}`);
            var resData = Object.assign({ type: 'SUCCESS_USER_INFO_V2_LANDING_PAGE_ACTION' }, data);
            dispatch(setKeyValue({ key: localStoreKeys.userDefaultRole, value: resData?.defaultRole }))
            dispatch(setKeyValue({ key: localStoreKeys.userEmailID, value: resData?.emailId }))
            dispatch(resData);
        }
    };
};

const FetchUserAccessAction = (oktaTokenData = 'test.user@pepsico.com') => {
    return async function (dispatch) {
        const email = oktaTokenData?.email
        if (email) {
            const data = await getApiCall(`${appConstants.BASE_URL}/user/user-access?emailId=${email}`);
           // const data = await getApiCall(`${appConstants.BASE_URL}/user/user-info?emailId=surta.ram.contractor@pepsico.com`);
            // const data = await getApiCall(`${appConstants.BASE_URL}/user/user-info?emailId=rishikeshramesh.patil@fractal.ai`);
            var resData = Object.assign({ type: 'SUCCESS_USER_ACCESS_ACTION' }, data);
            dispatch(setKeyValue({ key: localStoreKeys.userDefaultRole, value: resData?.defaultRole }))
            dispatch(setKeyValue({ key: localStoreKeys.userEmailID, value: resData?.emailId }))
            dispatch(resData);
        }
    };
};

const FetchUserInfoAction = (oktaTokenData = 'test.user@pepsico.com') => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_USER_INFO_ACTION' });
        try {
            const email = oktaTokenData?.email
            if (email) {
                const data = await getApiCall(`${appConstants.BASE_URL}/user/user-info?emailId=${email}`);
                var resData = Object.assign({ type: 'SUCCESS_USER_INFO_ACTION' }, data);
                var resDataUserInfo = Object.assign({ type: 'SUCCESS_LANDING_PAGE_ACTION' }, data);
                dispatch(setKeyValue({ key: localStoreKeys.userDefaultRole, value: resData?.defaultRole }))
                dispatch(setKeyValue({ key: localStoreKeys.userEmailID, value: resData?.emailId }))
                dispatch(resData);
                dispatch(resDataUserInfo);
            }

        } catch (error) {
            dispatch({ type: 'ERROR_USER_INFO_ACTION', error });
        }
    };
};


const FetchTileKpiOverviewAction = (oktaTokenData = 'test.user@pepsico.com') => {
    return async function (dispatch) {
        const email = oktaTokenData?.email
        if (email) {
            const data = await getApiCall(`${appConstants.BASE_URL}/user/tiles-order?emailId=${email}`);
            var resData = Object.assign({ type: 'SUCCESS_TILE_KPI_OVERVIEW_ACTION' }, {tilesOrderDetails: data});
            // dispatch(setKeyValue({ key: localStoreKeys.userDefaultRole, value: resData?.defaultRole }))
            // dispatch(setKeyValue({ key: localStoreKeys.userEmailID, value: resData?.emailId }))
            dispatch(resData);
        }
    };
};


const FetchMaxDateAction = (oktaTokenData) => {
    return async function (dispatch) {
        const email = oktaTokenData?.email
        if (email) {
            const data = await getApiCall(`${appConstants.BASE_URL}/app-data/max-date`);
            var resData = Object.assign({ type: 'SUCCESS_MAX_DATE_ACTION' }, data);
            dispatch(resData);
        }
    };
};
const FetchBlankCategoriesAction = (oktaTokenData) => {
    return async function (dispatch) {
        const email = oktaTokenData?.email
        if (email) {
            const data = await getApiCall(`${appConstants.BASE_URL}/category/l1-category`);
            var resData = Object.assign({ type: 'SUCCESS_BLANK_CATEGORY_ACTION' }, data);
            dispatch(resData);
        }
    };
};

const FetchSpendCardDataAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/spend-analytics/main-page-data`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_SPEND_CARD_ACTION' }, data);
        dispatch(resData);
    }
}
const FetchSupplierPerfMainAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplier-performance/main-page-data`, requestObj)
        // const data = await postApiCall(`${appConstants.BASE_URL}/supplier-performance/inhouse-main-page-data`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_COMAN_CARD_ACTION' }, data);
        dispatch(resData);
    }
}
const FetchContractfMainAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/contract-management/main-page-data`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_CONTRACT_CARD_ACTION' }, data);
        dispatch(resData);
    }
}
const FetchSustainabilityMainAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/sustainability/main-page-data`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_SUSTAINABILITY_CARD_ACTION' }, data);
        dispatch(resData);
    }
}
const FetchArchletMainAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/archlet/main-page-details`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_ARCHLET_CARD_ACTION' }, data);
        dispatch(resData);
    }
}

const FetchMarketIntelInhouseMainAction = (requestObj) => {
    return async function (dispatch) {
        //const tempBaseUrl = "https://apim-na.dev.mypepsico.com/cgf/buyers-console-api/v1"; // TO BE CHANGED
        // const data = await postApiCall(`${tempBaseUrl}/market-intelligence/main-page-data`, requestObj)

        const data = await postApiCall(`${appConstants.BASE_URL}/market-intelligence/main-page-data`, requestObj)

        var resData = Object.assign({ type: 'SUCCESS_MI_INHOUSE_CARD_ACTION' }, data);
        dispatch(resData);
    }
}

const FetchR2PMainAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/my-ris/main-page-data`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_R2P_INSIGHTS_CARD_ACTION' }, data);
        dispatch(resData);
    }
}

const FetchProcurementSearchIndexAction = () => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/api/procurement-capabilities/search-index`);
        const searchIndex = Array.isArray(data)
            ? data
            : data?.cards || data?.results || data?.items || data?.searchIndex || data?.data?.cards || data?.data?.results || data?.data?.items || data?.data?.searchIndex || data?.data || [];
        dispatch({
            type: 'SUCCESS_PROC_SEARCH_INDEX_ACTION',
            searchIndex: Array.isArray(searchIndex) ? searchIndex : [],
        });
    };
};

const FetchProcurementPageAction = (pageId = 1) => {
    return async function (dispatch) {
        const routeValue = String(pageId || '');
        const learningUrl = pageId === 1 || !pageId
            ? '/procurement-capabilities'
            : routeValue === '/procurement-capabilities'
                ? routeValue
                : routeValue.startsWith('/procurement-capabilities/')
                ? routeValue
                : `/procurement-capabilities/${routeValue}`;
        const isOverviewPage = learningUrl === '/procurement-capabilities';
        const endpoint = `${appConstants.BASE_URL}/api/procurement-capabilities/details?url=${learningUrl}`;
        const requests = [getApiCall(endpoint)];
        if (isOverviewPage) {
            requests.push(getApiCall(`${appConstants.BASE_URL}/api/procurement-capabilities/search-index`));
        }

        const [data, searchData] = await Promise.all(requests);
        // const data = await fetch(endpoint).then(response => response.json());
        const cardList = Array.isArray(data?.cardList)
            ? data.cardList
            : [];
        const searchIndex = isOverviewPage
            ? (Array.isArray(searchData)
                ? searchData
                : searchData?.cards || searchData?.results || searchData?.items || searchData?.searchIndex || searchData?.data?.cards || searchData?.data?.results || searchData?.data?.items || searchData?.data?.searchIndex || searchData?.data || [])
            : [];
        dispatch({
            type: 'SUCCESS_PROC_PAGE_ACTION',
            procurementLearning: data,
            courses: cardList,
            searchIndex: Array.isArray(searchIndex) ? searchIndex : [],
        });
    };
};

const FetchAgroToolsPageAction = () => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/agro/agro-info`);
        var resData = Object.assign({ type: 'SUCCESS_AGRO_TOOLS_PAGE_ACTION' , courses:data } );
        dispatch(resData);
    };
};


const FetchTaxonomyAction = () => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_TAXONOMY_DATA_ACTION' });
        try {
                const data = await getApiCall(`${appConstants.BASE_URL}/taxonomy/resources`);
                // const data= {
                //     "trainingResources": [
                //         {
                //             "name": "Onboarding Training",
                //             "url": "http://www.example.com/123"
                //         },
                //         {
                //             "name": "MyLearning (Coming soon)",
                //             "url": "http://www.example.com/123"
                //         }
                //     ],
                //     "mappingResources": [
                //         {
                //             "name": "2.0 Mapping file",
                //             "url": "https://pepsico.sharepoint.com/:f:/s/STDigitalProcurement/IgDmXehvIZ5bRb2HXVZKZJ6GAXcM2hy7LZczh2Vhp355UMU?e=mGxJfx&xsdata=MDV8MDJ8UGFsLlBhbGFuaWFwcGFuQHBlcHNpY28uY29tfGYyM2MxNWY3OTUwNjRjZjJhZTIwMDhkZWFmOGY1NTQ0fDQyY2MzMjk1Y2QwZTQ0OWNiOThlNWNlNWI1NjBjMWQzfDB8MHw2MzkxNDEyMjc0MDU3NTcwNzF8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpGYlhCMGVVMWhjR2tpT25SeWRXVXNJbFlpT2lJd0xqQXVNREF3TUNJc0lsQWlPaUpYYVc0ek1pSXNJa0ZPSWpvaVRXRnBiQ0lzSWxkVUlqb3lmUT09fDB8fHw%3d&sdata=ZUJmRHVxM1cxK3oyWjE1dXg2cFNHRUJLd2FDSmN5WnUzU08xQXJtQjFDOD0%3d"
                //         }
                //     ],
                //     "taxonomyOverview": [
                //         {
                //             "name": "Video of Proc Academy 2.0 overview",
                //             "url": "https://pepsico.sharepoint.com/:v:/s/STDigitalProcurement/IQDmN9uAahydQIEkbq0B1FFEAVQd3bnAt2eZAWB5f9mryeY?e=Lg0Dda&referrer=Outlook.Desktop&referrerScenario=email-linkwithoutembed&xsdata=MDV8MDJ8UGFsLlBhbGFuaWFwcGFuQHBlcHNpY28uY29tfGYyM2MxNWY3OTUwNjRjZjJhZTIwMDhkZWFmOGY1NTQ0fDQyY2MzMjk1Y2QwZTQ0OWNiOThlNWNlNWI1NjBjMWQzfDB8MHw2MzkxNDEyMjc0MDU3NDMxMTN8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpGYlhCMGVVMWhjR2tpT25SeWRXVXNJbFlpT2lJd0xqQXVNREF3TUNJc0lsQWlPaUpYYVc0ek1pSXNJa0ZPSWpvaVRXRnBiQ0lzSWxkVUlqb3lmUT09fDB8fHw%3d&sdata=ajNzNmJSZUhMSmpXdDloZGQvUll2YXJ1NythZy9SanVpb1p5aE8wbVI5MD0%3d"
                //         }
                //     ],
                //     "additionalResources": [
                //         {
                //             "name": "Playbook",
                //             "url": "http://www.exp.com/123"
                //         },
                //         {
                //             "name": "Know-say-do toolkits - Part 1",
                //             "url": "https://pepsico.sharepoint.com/:b:/s/STDigitalProcurement/IQARPm7DmElGTomMYxdooaogAdDjVpM_mKhJGxd8xCBD9ZY?e=bSXcTw&xsdata=MDV8MDJ8UGFsLlBhbGFuaWFwcGFuQHBlcHNpY28uY29tfGYyM2MxNWY3OTUwNjRjZjJhZTIwMDhkZWFmOGY1NTQ0fDQyY2MzMjk1Y2QwZTQ0OWNiOThlNWNlNWI1NjBjMWQzfDB8MHw2MzkxNDEyMjc0MDU3NjM3NzN8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpGYlhCMGVVMWhjR2tpT25SeWRXVXNJbFlpT2lJd0xqQXVNREF3TUNJc0lsQWlPaUpYYVc0ek1pSXNJa0ZPSWpvaVRXRnBiQ0lzSWxkVUlqb3lmUT09fDB8fHw%3d&sdata=M0thNlRUMzNFdW9NVkVEb0NlblhST1hCTlRGaTBEVzBBcUduTU1ha091WT0%3d"
                //         },
                //         {
                //             "name": "Know-say-do toolkits - Part 2",
                //             "url": "https://pepsico.sharepoint.com/:b:/s/STDigitalProcurement/IQA4n3EbXGOLS4wB64_BVNmvARdVvjVK04vZFGWz_54IbAc?e=bSqacC&xsdata=MDV8MDJ8UGFsLlBhbGFuaWFwcGFuQHBlcHNpY28uY29tfGYyM2MxNWY3OTUwNjRjZjJhZTIwMDhkZWFmOGY1NTQ0fDQyY2MzMjk1Y2QwZTQ0OWNiOThlNWNlNWI1NjBjMWQzfDB8MHw2MzkxNDEyMjc0MDU3Njk4NTZ8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpGYlhCMGVVMWhjR2tpT25SeWRXVXNJbFlpT2lJd0xqQXVNREF3TUNJc0lsQWlPaUpYYVc0ek1pSXNJa0ZPSWpvaVRXRnBiQ0lzSWxkVUlqb3lmUT09fDB8fHw%3d&sdata=bXZTN3R6RFlRWG82VDh3UWh0VW9sdGZuZWpRQWxHYnM1c05KVmxGSGlCQT0%3d"
                //         },
                //         {
                //             "name": "Program Executive summary",
                //             "url": "https://pepsico.sharepoint.com/:b:/s/STDigitalProcurement/IQD_6QI3nbQDR6IFThFme34-AYWpisFgHf7wt3UoI5ONFzw?e=LUA22k&xsdata=MDV8MDJ8UGFsLlBhbGFuaWFwcGFuQHBlcHNpY28uY29tfGYyM2MxNWY3OTUwNjRjZjJhZTIwMDhkZWFmOGY1NTQ0fDQyY2MzMjk1Y2QwZTQ0OWNiOThlNWNlNWI1NjBjMWQzfDB8MHw2MzkxNDEyMjc0MDU3NzU5NDh8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpGYlhCMGVVMWhjR2tpT25SeWRXVXNJbFlpT2lJd0xqQXVNREF3TUNJc0lsQWlPaUpYYVc0ek1pSXNJa0ZPSWpvaVRXRnBiQ0lzSWxkVUlqb3lmUT09fDB8fHw%3d&sdata=QmtQM215Y280RnNpRC9UVllON05pRWlDeElEYVloRHJhZzhQWnZ1bU1Naz0%3d"
                //         },
                //         {
                //             "name": "FAQs",
                //             "url": "https://pepsico.sharepoint.com/:b:/s/STDigitalProcurement/IQCqdaTUInpuSbrEdGISZ8STAUBOXrxaSQAqaUWZ-CLCzMo?e=4WfbXx&xsdata=MDV8MDJ8UGFsLlBhbGFuaWFwcGFuQHBlcHNpY28uY29tfGYyM2MxNWY3OTUwNjRjZjJhZTIwMDhkZWFmOGY1NTQ0fDQyY2MzMjk1Y2QwZTQ0OWNiOThlNWNlNWI1NjBjMWQzfDB8MHw2MzkxNDEyMjc0MDU3ODIwNzB8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpGYlhCMGVVMWhjR2tpT25SeWRXVXNJbFlpT2lJd0xqQXVNREF3TUNJc0lsQWlPaUpYYVc0ek1pSXNJa0ZPSWpvaVRXRnBiQ0lzSWxkVUlqb3lmUT09fDB8fHw%3d&sdata=bFNaMXZ3TFJPb0lxOHJNbUFzRDQ1RVo2cFJ1RU1DNWQ3NEtGd3FkMGhUVT0%3d"
                //         }
                //     ]
                // };
                var resData = Object.assign({ type: 'SUCCESS_TAXONOMY_DATA_ACTION' }, data);
                dispatch(resData);
            
        } catch (error) {
            dispatch({ type: 'ERROR_TAXONOMY_DATA_ACTION', error });
        }
    };
};


export {
    FetchLandingPageAction,
    FetchUserInfoV2LandingPageAction,
    FetchUserAccessAction,
    FetchSpendCardDataAction,
    FetchSupplierPerfMainAction,
    FetchContractfMainAction,
    FetchMarketIntelInhouseMainAction,
    FetchSustainabilityMainAction,
    FetchBlankCategoriesAction,
    FetchMaxDateAction,
    FetchArchletMainAction,
    FetchTileKpiOverviewAction,
    FetchR2PMainAction,
    FetchProcurementSearchIndexAction,
    FetchProcurementPageAction,
    FetchAgroToolsPageAction,
    FetchUserInfoAction,
    FetchTaxonomyAction
}